export default __webpack_public_path__ + "static/media/method-draw-image.17c13811.svg";